import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaDispersionPagosDividirComponent {
  idProyecto
  idNomina
  idTipoPago
  idMetodoPago
  idMoneda
  data
  onChange
  confirmando = false

  $onChanges (changes) {
    if (changes.data) {
      this.data = this.data.filter((item) => item.status_aprobado && !item.status_pagado)
      this.omitidos = changes.data.currentValue.length - this.data.length
    }
  }

  actualizar (data) {
    this.confirmando = false

    if (data) {
      this.onChange({$event: {data: data}})
    }
  }
}

module.component('nominasNominaDispersionPagosDividir', {
  controller: NominasNominaDispersionPagosDividirComponent,
  template,
  bindings: {
    idProyecto: '<',
    idNomina: '<',
    idTipoPago: '<',
    idMetodoPago: '<',
    idMoneda: '<',
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/dispersion/pagos/dividir/component.js